/* LUMÉA — scripts del tema (sin librerías externas) */
(function () {
  'use strict';

  var T = window.mtTheme || {};

  function formatMoney(cents) {
    var fmt = T.moneyFormat || '{{amount_with_comma_separator}} €';
    var value = (cents / 100);
    function withSep(n, dec, thou, decimals) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(dec);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withSep(value, '.', ',', 2);
        case 'amount_no_decimals': return withSep(value, '.', ',', 0);
        case 'amount_with_comma_separator': return withSep(value, ',', '.', 2);
        case 'amount_no_decimals_with_comma_separator': return withSep(value, ',', '.', 0);
        case 'amount_with_apostrophe_separator': return withSep(value, '.', "'", 2);
        default: return withSep(value, ',', '.', 2);
      }
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  /* ---------- Revelado ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || document.body.classList.contains('no-anim')) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Cifras animadas ---------- */
  function initCounters() {
    var els = document.querySelectorAll('[data-count]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, end = parseFloat(el.getAttribute('data-count')) || 0;
        var dec = (String(end).split('.')[1] || '').length, start = null, dur = 1600;
        if (document.body.classList.contains('no-anim')) { el.textContent = end.toFixed(dec); return; }
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1), eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (end * eased).toFixed(dec).replace('.', ',');
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var h = document.querySelector('[data-header]');
    if (h) {
      var onScroll = function () { h.classList.toggle('is-scrolled', window.scrollY > 10); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    var nav = document.querySelector('[data-mobile-nav]');
    document.querySelectorAll('[data-mobile-open]').forEach(function (b) {
      b.addEventListener('click', function () { if (nav) { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; } });
    });
    document.querySelectorAll('[data-mobile-close]').forEach(function (b) {
      b.addEventListener('click', function () { if (nav) { nav.classList.remove('is-open'); document.body.style.overflow = ''; } });
    });
    var sBtn = document.querySelector('[data-search-toggle]'), sBox = document.querySelector('[data-search-box]');
    if (sBtn && sBox) sBtn.addEventListener('click', function () {
      sBox.hidden = !sBox.hidden;
      if (!sBox.hidden) { var i = sBox.querySelector('input'); if (i) i.focus(); }
    });
  }

  /* ---------- Parallax suave del hero ---------- */
  function initParallax() {
    var els = document.querySelectorAll('[data-parallax]');
    if (!els.length || document.body.classList.contains('no-anim') || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    function update() {
      els.forEach(function (el) {
        var k = parseFloat(el.getAttribute('data-parallax')) || 0;
        var r = el.getBoundingClientRect();
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * k * -0.01;
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  /* ---------- Formularios de producto ---------- */
  function initProductForms() {
    document.querySelectorAll('[data-product-form]').forEach(function (wrap) {
      if (wrap.getAttribute('data-bound')) return; wrap.setAttribute('data-bound', '1');
      var dataEl = wrap.querySelector('[data-variants]');
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
      var idInput = wrap.querySelector('[data-variant-id]');
      var priceEl = wrap.querySelector('[data-price]');
      var compareEl = wrap.querySelector('[data-compare]');
      var badgeEl = wrap.querySelector('[data-badge]');
      var pctEl = wrap.querySelector('[data-badge-pct]');
      var btn = wrap.querySelector('[data-add-btn]');
      var lbl = wrap.querySelector('[data-add-label]');
      var fieldsets = wrap.querySelectorAll('.mt-variant');

      function currentOptions() {
        var opts = [];
        fieldsets.forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          opts.push(c ? c.value : null);
          var out = fs.querySelector('[data-option-value]');
          if (out && c) out.textContent = c.value;
        });
        return opts;
      }
      function update() {
        var opts = currentOptions();
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
        if (!v) { if (btn) btn.disabled = true; if (lbl) lbl.textContent = 'No disponible'; return; }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (compareEl) { compareEl.hidden = !(v.compare > v.price); compareEl.textContent = formatMoney(v.compare); }
        if (badgeEl) {
          var pct = v.compare > v.price ? Math.round((v.compare - v.price) * 100 / v.compare) : 0;
          badgeEl.hidden = pct === 0; if (pctEl) pctEl.textContent = pct;
        }
        if (btn) btn.disabled = !v.available;
        if (lbl) lbl.textContent = v.available ? lbl.getAttribute('data-label-default') : lbl.getAttribute('data-label-soldout');
        if (wrap.closest('[data-pdp]')) {
          try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
          if (v.media) document.dispatchEvent(new CustomEvent('mt:variant-media', { detail: { media: v.media } }));
        }
        document.dispatchEvent(new CustomEvent('mt:variant', { detail: { variant: v } }));
      }
      fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });

      var qty = wrap.querySelector('[data-qty]');
      if (qty) {
        var input = qty.querySelector('input');
        qty.querySelector('[data-qty-minus]').addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
        qty.querySelector('[data-qty-plus]').addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
      }

      var form = wrap.querySelector('form');
      var err = wrap.querySelector('[data-form-error]');
      if (form && T.cartDrawer) {
        form.addEventListener('submit', function (ev) {
          ev.preventDefault();
          if (btn) btn.setAttribute('aria-busy', 'true');
          if (err) err.hidden = true;
          fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
          }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) {
              if (btn) btn.removeAttribute('aria-busy');
              if (!res.ok) { if (err) { err.textContent = res.j.description || 'No se pudo añadir.'; err.hidden = false; } return; }
              Cart.open();
            }).catch(function () { form.submit(); });
        });
      }
    });
  }

  /* ---------- Añadir rápido (tarjetas y packs) ---------- */
  function initQuickAdd() {
    if (document.documentElement.getAttribute('data-quick-add-bound')) return;
    document.documentElement.setAttribute('data-quick-add-bound', '1');
    document.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('[data-card-variant]');
      if (!sel) return;
      var b = sel.closest('.mt-card').querySelector('[data-quick-add]');
      if (b) b.setAttribute('data-variant-id', sel.value);
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-quick-add]');
      if (!b) return;
      e.preventDefault();
      var items = [];
      var scope = b.getAttribute('data-pack') !== null ? b.closest('[data-pack-box]') : null;
      if (scope) {
        scope.querySelectorAll('[data-pack-item]').forEach(function (it) {
          var s = it.querySelector('select');
          items.push({ id: parseInt(s ? s.value : it.getAttribute('data-variant-id'), 10), quantity: 1 });
        });
      } else {
        items.push({ id: parseInt(b.getAttribute('data-variant-id'), 10), quantity: 1 });
      }
      var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      var label = b.textContent;
      b.setAttribute('aria-busy', 'true');
      fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          b.removeAttribute('aria-busy');
          if (!res.ok) { b.textContent = res.j.description || 'No se pudo añadir'; setTimeout(function () { b.textContent = label; }, 3000); return; }
          if (T.cartDrawer) Cart.open(); else window.location.href = root + 'cart';
        }).catch(function () { b.removeAttribute('aria-busy'); window.location.href = root + 'cart'; });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGallery() {
    var g = document.querySelector('[data-gallery]');
    if (!g || g.getAttribute('data-bound')) return; g.setAttribute('data-bound', '1');
    var main = g.querySelector('[data-gallery-main]');
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-thumb]'));
    var idx = 0;
    function show(i) {
      if (!thumbs.length) return;
      idx = (i + thumbs.length) % thumbs.length;
      var t = thumbs[idx];
      main.classList.add('is-fading');
      setTimeout(function () {
        main.src = t.getAttribute('data-src');
        main.srcset = t.getAttribute('data-srcset') || '';
        main.alt = t.getAttribute('data-alt') || '';
        main.classList.remove('is-fading');
      }, 180);
      thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var prev = g.querySelector('[data-gallery-prev]'), next = g.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    var sx = null;
    main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (sx === null) return; var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1)); sx = null;
    });
    document.addEventListener('mt:variant-media', function (e) {
      var i = thumbs.findIndex(function (t) { return t.getAttribute('data-media-id') == e.detail.media; });
      if (i > -1) show(i);
    });
  }

  /* ---------- Barra de compra fija ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var target = document.querySelector('[data-pdp] [data-add-btn]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      // En móvil también se muestra mientras el botón aún no ha entrado en pantalla
      var mobile = window.matchMedia('(max-width: 989px)').matches;
      bar.classList.toggle('is-visible', !e.isIntersecting && (mobile || e.boundingClientRect.top < 0));
    });
    io.observe(target);
    var b = bar.querySelector('[data-sticky-btn]');
    if (b) b.addEventListener('click', function () { target.click(); });
    var p = bar.querySelector('[data-sticky-price]');
    document.addEventListener('mt:variant', function (e) {
      if (p) p.textContent = formatMoney(e.detail.variant.price);
      if (b) b.disabled = !e.detail.variant.available;
    });
  }

  /* ---------- Carrito lateral ---------- */
  var Cart = {
    el: null,
    root: function () { return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/'); },
    open: function () {
      if (!this.el) { window.location.href = this.root() + 'cart'; return; }
      this.refresh().then(function () {
        Cart.el.classList.add('is-open'); Cart.el.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
      });
    },
    close: function () { if (!this.el) return; this.el.classList.remove('is-open'); this.el.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; },
    refresh: function () {
      return fetch(this.root() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { Cart.render(c); return c; });
    },
    change: function (key, qty) {
      return fetch(this.root() + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (c) { Cart.render(c); });
    },
    render: function (c) {
      document.querySelectorAll('[data-cart-count-badge]').forEach(function (b) { b.textContent = c.item_count; b.hidden = c.item_count === 0; });
      if (!this.el) return;
      this.el.querySelector('[data-cart-count]').textContent = '(' + c.item_count + ')';
      this.el.querySelector('[data-cart-total]').textContent = formatMoney(c.total_price);
      var box = this.el.querySelector('[data-cart-items]');
      if (!c.items.length) { box.innerHTML = '<p class="mt-drawer__empty">Tu carrito está vacío.</p>'; }
      else {
        box.innerHTML = c.items.map(function (it) {
          var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2') : '';
          var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="mt-dline__var">' + esc(it.variant_title) + '</p>' : '';
          var was = it.original_line_price > it.final_line_price ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '';
          return '<div class="mt-dline">' +
            (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span></span>') +
            '<div><p class="mt-dline__title">' + esc(it.product_title) + '</p>' + variant +
            '<div class="mt-qty" style="display:inline-flex"><button type="button" class="mt-qty__btn" data-line-key="' + esc(it.key) + '" data-line-qty="' + (it.quantity - 1) + '" aria-label="Restar">−</button>' +
            '<span class="mt-qty__input" style="display:inline-block">' + it.quantity + '</span>' +
            '<button type="button" class="mt-qty__btn" data-line-key="' + esc(it.key) + '" data-line-qty="' + (it.quantity + 1) + '" aria-label="Sumar">+</button></div></div>' +
            '<div class="mt-dline__price">' + formatMoney(it.final_line_price) + was + '</div></div>';
        }).join('');
      }
      this.renderPack(c);
      var fs = this.el.querySelector('[data-free-ship]');
      if (fs && T.freeShip > 0) {
        fs.hidden = false;
        var left = T.freeShip - c.total_price;
        fs.querySelector('[data-free-ship-text]').innerHTML = left > 0
          ? 'Te faltan <strong>' + formatMoney(left) + '</strong> para el envío gratis'
          : '¡Enhorabuena! Tu envío es <strong>gratis</strong> ✦';
        fs.querySelector('[data-free-ship-bar]').style.width = Math.min(100, c.total_price * 100 / T.freeShip) + '%';
      }
    },
    // Aviso de packs: cuenta unidades por categoría y dice cuánto falta para el siguiente tramo
    renderPack: function (c) {
      var box = this.el.querySelector('[data-pack-hint]');
      var src = this.el.querySelector('[data-pack-groups]');
      if (!box || !src) return;
      var groups = [];
      try { groups = JSON.parse(src.textContent); } catch (e) { return; }
      var best = null;
      groups.forEach(function (g) {
        var n = 0;
        c.items.forEach(function (it) { if (g.ids.indexOf(it.product_id) > -1) n += it.quantity; });
        if (n > 0 && (!best || n > best.n)) best = { g: g, n: n };
      });
      if (!best) { box.hidden = true; return; }
      var name = esc(best.g.name), link = ' <a href="' + esc(best.g.url) + '">Ver productos</a>';
      box.innerHTML = best.n === 1
        ? '✦ Añade 1 producto más de <strong>' + name + '</strong> y ahorra un <strong>10 %</strong>.' + link
        : best.n === 2
          ? '✦ Tienes el <strong>−10 %</strong>. Añade 1 más de <strong>' + name + '</strong> y pasa al <strong>−20 %</strong>.' + link
          : '✦ ¡Tienes el <strong>−20 %</strong> en ' + name + ' aplicado!';
      box.hidden = false;
    },
    init: function () {
      this.el = document.querySelector('[data-cart-drawer]');
      if (!this.el) return;
      this.el.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { Cart.close(); }); });
      this.el.addEventListener('click', function (e) {
        var b = e.target.closest('[data-line-key]');
        if (b) Cart.change(b.getAttribute('data-line-key'), parseInt(b.getAttribute('data-line-qty'), 10));
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') Cart.close(); });
      document.querySelectorAll('[data-cart-open]').forEach(function (a) {
        a.addEventListener('click', function (e) { if (T.cartDrawer) { e.preventDefault(); Cart.open(); } });
      });
    }
  };
  window.mtCart = Cart;

  /* ---------- FAQ: solo uno abierto ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-acc-group]').forEach(function (grp) {
      var items = grp.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* ---------- Fecha estimada de entrega (días hábiles, sin fines de semana) ---------- */
  function initDelivery() {
    document.querySelectorAll('[data-delivery]').forEach(function (el) {
      var out = el.querySelector('[data-delivery-out]');
      if (!out) return;
      function addBusinessDays(n) {
        var d = new Date();
        while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
        return d;
      }
      function fmt(d) {
        try { return d.toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/[.,]/g, ''); }
        catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); }
      }
      var min = parseInt(el.getAttribute('data-min'), 10) || 7;
      var max = parseInt(el.getAttribute('data-max'), 10) || 14;
      var tpl = el.getAttribute('data-text') || 'Recíbelo entre el {min} y el {max}';
      out.innerHTML = tpl.replace('{min}', esc(fmt(addBusinessDays(min)))).replace('{max}', esc(fmt(addBusinessDays(max))));
      el.hidden = false;
    });
  }

  function init() {
    initReveal(); initCounters(); initHeader(); initParallax();
    Cart.init(); initQuickAdd(); initProductForms(); initGallery(); initStickyAtc(); initAccordions(); initDelivery();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Editor de Shopify: reinicia al cargar/editar secciones */
  document.addEventListener('shopify:section:load', function () { initReveal(); initCounters(); initProductForms(); initGallery(); initAccordions(); initParallax(); initDelivery(); });
})();
